import { Component,  NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges, TemplateRef, forwardRef} from '@angular/core';
import {DemoService} from './../../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import { MysqlService } from './../../../../services/mysql.service';

import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';
// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {Observable, Subject, map, Subscription} from 'rxjs';

import {CreateJob2Component} from './../../create-job-2/create-job-2.component';

import { FileUploaderService } from './../../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../../services/global-functions.service';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-subject-agent-brands',
  templateUrl: './subject-agent-brands.component.html',
  styleUrls: ['./subject-agent-brands.component.css'],
})
export class SubjectAgentBrandsComponent implements OnInit, OnDestroy {

  @Input() subject_id: number;
  @Input() job_id: number;
  nav: any;
  currentUserVAR: any;
  sessionUserId: any;
  sessionBrandId: any;
  currentBrandVAR: any;
  staffList: Object;
  @Input() user_id: number;
  @Input() subject_model: any;

  
  dropdownSettings2 = {};
  assignedList: Object;
  brandAgentsList: any;
  assignedBrandList: Object;
  sessionUsername: any;
  all_router_details: string;
  allAgentRecipients: any[];
  assignedAgentsList2: any;
  model: any;
  metric_qualification_renewal_date: Date;
  brand: any;
  today_format: Date;
  agent_qualification_status_expired: number;

  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     public HttpClient:HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public gfunc: GlobalFunctionsService
  ) { 

    this.nav = document.querySelector('nav.navbar');
   

// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));


    
    // drop down for assigned users
    this.dropdownSettings2 = {
      singleSelection: false,
      idField: 'brand_id',
      textField: 'name', // brand name
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 15,
      allowSearchFilter: true,
      enableCheckAll: false,
     // enableUnselectAll: false,
    };
    
  



  }

  ngOnInit() {


     // new drop down for brand agents.
     this.getBrandAgents();

    // this.getBrandUsers('94'); // for the drop down
  //  this.getBrandUsersAgents();
    this.getSubjectAgentAssigned(this.subject_id);
    this.getSubjectAgentBrandsAssigned(this.subject_id);
    
    // expiry check
    this.getSubjectAgentBrandsAssigned_comms(this.subject_id);
   

  };









// drop down 


// multi select setup and action.
onItemSelect(item:any){
  // console.log(item);
   // this.createTraceAssignedUser(item); // insert into table
   // this.getTraceAssigned(item.trace_id); // refresh the list
   }
   onSelectAll(items: any){
  // console.log(items);
   };


   onItemSelectAssinged(item: any, job_id, subject_id, brand_id){
    // console.log(item);
    this.createSubjectAgentAssignedBrand(item, job_id, subject_id, brand_id); // insert into table
   // added to auto start the strace
  //  this.startTraceDropdown(trace_id, this.sessionUserId);
    // this.getTraceAssigned(trace_id); // refresh the list
    // console.log(item, trace_id, user_id);
     };


     onSelectAllAssigned(items: any, subject_id, brand_id?){
     console.log(items, subject_id, brand_id);
       // user id not passed.
     // TODO // need to create a delete all with trace_id from assigned_user table.
              this.deleteSubjectAgentAssignedAll(items, subject_id);
             // this.toastr.success('Removed All Agents from Job');
             // test a loop
           //   const num2 = items;
             // delete loop
            /* num2.forEach(item => {
             this.deleteTraceAssignedAll(item.trace_id);
             });
             */



// TO DO // need to create an insert array of items mysql ... function. // maybe get from exec upload files fuction and sef_url etc..
// this.createTraceAssignedUserMultiple(items, trace_id);
             const num = items;
             // insert loop
             num.forEach(item => {
             //  console.log(item);
             this.createSubjectAgentAssignedBrand(item, this.job_id, this.subject_id, item.brand_id); // did not work so place a copy here
             });


          // refresh the list
         // refresh the trace
     // this.startTraceDropdown(this.job_id, this.sessionUserId);
      // this.getTraceById(this.trace_id);

     
     };





     onDeSelectAssigned(item: any, subject_id, brand_id)
     {
       this.deleteSubjectAgentAssigned(item, subject_id, item.brand_id);
       this.toastr.success('Removed Agent from Job');
       // refresh the trace
      // this.getTraceById(this.trace_id);
       // console.log(item);
     };

/*
Callback Methods
onSelect - Return the selected item when an item is checked. Example : (onSelect)="onItemSelect($event)"
onSelectAll - Return the all items. Example : (onSelectAll)="onSelectAll($event)".
onDeSelect - Return the unselected item when an item is unchecked.
Example : (onDeSelect)="onItemDeSelect($event)" onFilterChange - Return the key press. Example : (onFilterChange)="onFilterChange($event)"

*/
// end drop down


// gets the list of users assiciated for drop down.
getBrandUsersAgents() {
  this._demoService.getBrandUsersAgents().subscribe(
     data => { this.staffList = data;
    },
     err => console.error(err),
     () => console.log('Candidates Loaded.')
   );
 }

 // need to get users of type agent.


 /*
 getTraceAssignedList(trace_id) {
  this._demoService.getTraceAssigned(trace_id).subscribe(
     data => { this.assigned_to_list = data;
    },
     err => console.error(err),
     () => console.log('Candidates Loaded.')
   );
 }
 */

 // need to get brand agents.
 getBrandAgents() {
  this._demoService.getBrandAgents().subscribe(
     data => { this.brandAgentsList = data;
    },
     err => console.error(err),
     // () => console.log('Agent Brands Loaded.')
   );
 }


 getSubjectAgentAssigned(subject_id) {
  this._demoService.getSubjectAgentsAssigned(subject_id).subscribe(
     data => { this.assignedList = data;
    },
     err => console.error(err),
     // () => console.log('Loaded Assigned Agents Loaded.')
   );
 }

 getSubjectAgentBrandsAssigned(subject_id) {
  this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
     data => { this.assignedBrandList = data;

    },
     err => console.error(err),
     // () => console.log('Loaded Assigned Agents Loaded.')
   );
 }





 createSubjectAgentAssignedUser(item, job_id, subject_id, user_id) {
  this._demoService.createSubjectAssigedAgent(item, job_id, subject_id, user_id, this.subject_model.subject_number).subscribe(
     data => { // this.model = data;
       // refresh the list
      // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
     this.toastr.success('Agents Added to Subject');
     // Subject to reload the manager component parent.
    //  TraceCandidateManagerComponent.returned.next(false);
    // this.getTraceMysql(trace_id);
       return true;
     },
     error => {
       console.error('Error saving Job Agents Members!');
      return console.log(error);
     }
    // err => console.error(err),
    // () => console.log('done updates')
);
}


createSubjectAgentAssignedBrand(item, job_id, subject_id, brand_id) {
  this._demoService.createSubjectAssigedAgent(item, job_id, subject_id, brand_id, this.subject_model.subject_number).subscribe(
     data => { // this.model = data;
       // refresh the list
      // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
     this.toastr.success('Agents Added to Subject');
    let model = {
      item: item,
      job_id: job_id,
      subject_id: subject_id,
      brand_id: brand_id,
      ...this.subject_model
     }
     this.gfunc.insertLog_UpdateSubjectAgentAdded(model);
     // Subject to reload the manager component parent.
    //  TraceCandidateManagerComponent.returned.next(false);
    // this.getTraceMysql(trace_id);
       return true;
     },
     error => {
       console.error('Error saving Job Agents Members!');
      return console.log(error);
     }
    // err => console.error(err),
    // () => console.log('done updates')
);
}

// not required and blank in _demo from delete
createTraceAssignedUserMultiple(items, job_id) {
  this._demoService.createTraceAssigedUserMultiple(items, job_id).subscribe(
     data => { // this.model = data;
       // refresh the list
      // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
     this.toastr.success('Trace Staff Members Updated');
     // Subject to reload the manager component parent.
    //  TraceCandidateManagerComponent.returned.next(false);
    // this.getTraceMysql(trace_id);
       return true;
     },
     error => {
       console.error('Error saving All Trace Staff Members!');
      return console.log(error);
     }
    // err => console.error(err),
    // () => console.log('done updates')
);
}



deleteSubjectAgentAssigned(item, subject_id, user_id) {
    this._demoService.deleteSubjectAgentAssigned(item, subject_id, user_id).subscribe(
       data => {
         // refresh the list

         let model = {
          item: item,
          // job_id: job_id,
          subject_id: subject_id,
          // brand_id: brand_id
          user_id: user_id,
          ...this.subject_model
         }
         this.gfunc.insertLog_UpdateSubjectAgentRemoved(model);

         this.getSubjectAgentAssigned(subject_id);
         return true;
       },
       error => {
         console.error('Error removing user from list!');
        return console.log(error);
       }
    );

}


deleteSubjectAgentAssignedAll(item, subject_id) {
  this._demoService.deleteSubjectAgentAssignedAll(item, subject_id).subscribe(
     data => {
       // refresh the list
     //  this.getTraceAssigned(trace_id);
    // this.toastr.success('Agents All Removed');
     this.getSubjectAgentAssigned(subject_id);
       return true;
     },
     error => {
       console.error('Error removing all users from list!');
      return console.log(error);
     }
  );

}

// EXPUIRY FEATURES added to array and api quiery. just the expiery date field.
// need to get all associated agents of the job and push thier information to array
getSubjectAgentBrandsAssigned_comms(subject_id) {
  this.allAgentRecipients = [];
  this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
     data => { 
       this.assignedAgentsList2 = data;

       let newArr = data;
       let  count_of_items = Object.keys(newArr).length;
         // need to do a loop of subject_billing items (.length)
         for(let i=0;i < count_of_items; i++) {
         let res = newArr[i];



// this.metric_qualification_renewal_date = new Date(this.brand[0].qualification_renewal_date * 1000);
this.metric_qualification_renewal_date = new Date(newArr[i].qualification_renewal_date);
// this.metric_qualification_renewal_date = data[0].qualification_renewal_date;
this.today_format = new Date(this.gfunc.today);

// agent qualification cheker
// console.log('Agent Qualification Renewal Date: ', newArr[i].qualification_renewal_date);
// console.log('Today: ', new Date(this.gfunc.today));

if (this.metric_qualification_renewal_date <= this.today_format) {
  // console.log('NOTICE: This agent qualification has expired');
  this.agent_qualification_status_expired = 1; // invalid
}else {
  this.agent_qualification_status_expired = 0; // valid
}

         this.allAgentRecipients.push({
           recipient_name: res.name + '',
           recipient_email_address: res.email,
           recipient_brand_id: res.brand_id,
           recipient_subject_id: res.subject_id,
           recipient_brand_type_id: res.brand_type_id,
           recipient_user_id: null,
           recipient_user_level_id: null,
           recipient_type_name: 'Agent',
           qualification_expiry_date: res.qualification_expiry_date,
           agent_qualification_status_expired: this.agent_qualification_status_expired,
         });

         } // end for loop
       this.allAgentRecipients = this.allAgentRecipients; // ?? this may be causing errors.
       // set records to send to subject_notes data table
      //  this.model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);
      // console.log('this.allAgentRecipients:', JSON.stringify(this.allAgentRecipients));

    },
     err => console.error(err),
     // () => console.log('Loaded Assigned Agents Loaded.')
   );
 }



 RemoveElementFromAllRecipients_comms(key: number) {
  // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
  this.allAgentRecipients.forEach((value, index) => {
    if (value.recipient_name === key) {
      this.allAgentRecipients.splice(index, 1);
    }
  });
    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array

};


ngOnDestroy() {

};





}





